import { ChangeDetectionStrategy, Component, Input, OnChanges, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { Line } from './order-summary.models';
import { OrderSumaryService } from './order-summary.service';

import { Order } from '@api/order/order.models';
import { CurrencyInfo } from '@core/domain/models/store.models';
import { getLanguageCode } from '@core/infrastructure/state/core.selectors';
import { routerPublicQueries } from '@frontend/libs/duttirouter';
import { getRepaymentTotalOrderFormatted } from '@shared/order-payment/store/order-repayment.selectors';
import { NavigationService } from '@shared/services/navigation/navigation.service';

@Component({
    selector: 'dumb-order-summary',
    templateUrl: './order-summary.component.html',
    providers: [
        OrderSumaryService,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderSummaryComponent implements OnChanges {
    @Input() public order: Order;

    @Input() private readonly isHistory: boolean = false;

    @Input() public isSidebar: boolean = false;

    @Output() public readonly feelHistoricClicked = new EventEmitter<void>();

    public readonly baseUrl$: Observable<string> = this.navigationService.baseUrl$;

    public repayTotalPrice$: Observable<number | string> = this.store.select(getRepaymentTotalOrderFormatted);

    public isRepayment$: Observable<boolean> = this.store.select(routerPublicQueries.getUrlFromRouter).pipe(map((url: string) => url.includes('order-repayment')));

    public lines$: Observable<Line[]> = this.service.lines$;

    public showWWDisclaimer$: Observable<boolean> = this.service.showWWDisclaimer$;

    public currencyInfoAlternates$: Observable<CurrencyInfo[]> = this.service.currencyInfoAlternates$;

    public currencyCode$: Observable<string> = this.service.currencyCode$;

    public languageCode$: Observable<string> = this.store.select(getLanguageCode);

    public totalOrder$: Observable<number> = this.service.totalOrder$.pipe(
        filter((totalOrder) => totalOrder !== null)
    );

    public totalPoints$: Observable<number> = this.service.totalPoints$.pipe(
        filter((totalPoints) => totalPoints !== null)
    );

    constructor(
        public readonly service: OrderSumaryService,
        private readonly navigationService: NavigationService,
        private readonly store: Store,
    ) {}

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.order.currentValue !== changes.order.previousValue) {
            this.service.setOrder(changes.order.currentValue, this.isHistory);
        }
    }

    public viewFeelHistoric(): void {
        this.feelHistoricClicked.emit();
    }
}
